module.exports = "https://r.zoocdn.com/_next/static/images/apple-touch-icon-eef704c016bbaf62cf0574a23498d706.png";